import {useState} from 'react';
import HelpPageModal from "./HelpPageModal";
import downTimeIcon from '../../style/images/downtime-icon.svg';
import helpIcon from '../../style/images/help-icon.png';
import DownTimeIssuesPopUp from './DownTimeIssuesPopUp'

const HelpMark = ({pageId, appIsDown}) => {
    const [helpPageModal, setHelpPageModal] = useState(false);
    const [downTimeIssuesPopUpModal, setDownTimeIssuesPopUpModal] = useState(false);

    return (
        <div className="helpMark">
            <span onClick={() => setHelpPageModal(true)}>
                <img alt="help" className="cursorPointer" src={helpIcon}/>
            </span>
            {appIsDown?.status &&
                <span onClick={() => setDownTimeIssuesPopUpModal(true)}>
                    <img alt="help" className="cursorPointer ml-2" src={downTimeIcon}/>
                </span>
            }
            {helpPageModal &&
                <HelpPageModal hideHelpPageModal={() => setHelpPageModal(false)} pageId={pageId}/>
            }
            {downTimeIssuesPopUpModal &&
                <DownTimeIssuesPopUp
                    hideModal={() => setDownTimeIssuesPopUpModal(false)}
                    applicationList={appIsDown ? appIsDown.appDown : ['']}
                />
            }
        </div>
    );
}

export default HelpMark;
